import { useTranslation } from "react-i18next";

import type { AreaWithSensorInfo } from "@lib/store";
import { Button } from "@molecules";

import { AreaAdHocUse } from "./AreaAdHocUse";
import { AreaBookingCount } from "./AreaBookingCount";
import { AreaSensorStatus } from "./AreaSensorStatus";

type AreaAvailabilityProps = {
  area: AreaWithSensorInfo;
  onLearnMorePress: () => void;
};

// How busy the area is by its sensors, and how much of it is booked. "Learn more" explains the sensor statuses.
// Only bookable areas load their bookings.
export const AreaAvailability = ({ area, onLearnMorePress }: AreaAvailabilityProps) => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-[20px] font-semibold leading-[25px]">{t("screen:InviteesAvailability")}</h3>

      <AreaSensorStatus area={area} />

      {area.workspaceBookingPolicyType === "NonBookable" ? <AreaAdHocUse /> : <AreaBookingCount area={area} />}

      {area.sensorInformation && (
        <Button
          className="self-start"
          button="text"
          onClick={onLearnMorePress}>
          {t("hereAndNow:LearnMore")}
        </Button>
      )}
    </section>
  );
};
